"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ellipseString = ellipseString;
exports.formatPhoneNumber = formatPhoneNumber;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (_i = _i.call(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PHONE_NUMBER_RE = /\+1(\d{3})(\d{3})(\d{4})/;

function ellipseString() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 180;
  var endString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '...';
  return string.length > limit ? "".concat(string.slice(0, limit)).concat(endString) : string;
}

function formatPhoneNumber(phoneNumber) {
  if (!PHONE_NUMBER_RE.test(phoneNumber)) {
    throw new Error('Improperly formatted phone number given');
  }

  var _phoneNumber$match$sl = phoneNumber.match(PHONE_NUMBER_RE).slice(1, 4),
      _phoneNumber$match$sl2 = _slicedToArray(_phoneNumber$match$sl, 3),
      areaCode = _phoneNumber$match$sl2[0],
      firstThree = _phoneNumber$match$sl2[1],
      lastFour = _phoneNumber$match$sl2[2];

  return "(".concat(areaCode, ") ").concat(firstThree, "-").concat(lastFour);
}